import React from "react";
import {
  FlexWrapper,
  Container,
  Text5,
  Text2,
  Text3,
  Text4,
  FlexRowWrapper,
  GradiantButton1,
  GradiantText3,
  GradiantText2,
  Text6,
  Text5_6,
  Text4_5,
} from "../../../../Components/Common";
import { BackgroundImageContainer, BottomBgBackgroundConatiner } from "../SectionTwo/styles";

import {
  BlurbackgroundContainer,
  ExpandIcon,
  FAQContainer,
  FAQPoints,
  SecondBlurContainer,
  ShopifyImage,
  ShopifyImageWrapper,
} from "./style";
import DownArrow from "../../../../Assets/down-arrow.png";
import ShopifyImageImage from "../../../../Assets/shopify.png";
import CardOne from "../../../../Components/Cards/CardOne";
import { GridWrapper } from "../../../../Components/Cards/CardOne/styles";
import TempeleteOne from "../../../../Components/Template/Templete1";
import BackgroundImage from "../../../../Assets/BG.svg";
import CustomGrid from "../../../../Components/CustomGrid";
import { Heading } from "../../../../Components/Template/Templete1/style";
import GoogleImage from "../../../../Assets/google.png";
import ScrollAnimation from "react-animate-on-scroll";

const SectionThree = () => {
  return (
    <>
      <ScrollAnimation animateIn="fadeIn" duration={1} delay={100}>
        <BlurbackgroundContainer>
          <SecondBlurContainer>
            <Container width={"90%"}>
              <FlexWrapper gap={"10px"} justify={"space-between"} margin={"30px auto"} padding={'20px 0px'}>
                <Container width={"40%"} padding={"0px"} margin={"0px"}>
                  <FlexWrapper direction={"column"} width={"100%"}>
                    <Text6
                      color={"white"}
                      weight={700}
                      align={"left"}
                      margin={"4px 0px "}
                    >
                      ESCRIBELO KNOWS 50+ COPYWRITING SKILLS
                    </Text6>
                    <GradiantText3
                      weight={900}
                      align={"left"}
                      margin={"3px 0px"}
                    >
                      What All Can Escribelo <br /> Write For You?
                    </GradiantText3>
                    {/* <GradiantText2 weight={900}> Write For You?</GradiantText2> */}
                    <FlexWrapper
                      direction={"column"}
                      padding={"0rem 0rem"}
                      width={"100%"}
                      margin={"10px auto"}
                      align={"flex-start"}
                    >
                      <Text5_6 color={"white"} align={"left"} weight={600}>
                        Trained by copywriters and conversion experts, our AI
                        now has the skills to write killer content that captures
                        attention and converts.
                      </Text5_6>
                      <GradiantButton1
                        color={"white"}
                        width={"250px"}
                        margin={"10px 0px"}
                      >
                        See all templates
                      </GradiantButton1>
                    </FlexWrapper>
                  </FlexWrapper>
                </Container>

                <FlexWrapper
                  wrap={"wrap"}
                  width={"55%"}
                  gap={"30px"}
                  justify={"center"}
                  mobileWidth={'90%'}
                >
                  {Array.from(Array(6).keys()).map((item, index) => (
                    <div
                      style={{
                        width: "40%",
                        minWidth: "250px",
                        maxWidth: "300px",
                      }}
                    >
                      <CardOne
                        title={"GOOGLE ADS HEADLINE"}
                        title2={""}
                        description={
                          'Create high converting copy for the "Headlines" section of your Google Ads.'
                        }
                        imageSize={40}
                        imageUrl={GoogleImage}
                        key={index}
                        fontSize={"large"}
                      />
                    </div>
                  ))}
                </FlexWrapper>
              </FlexWrapper>
            </Container>
          </SecondBlurContainer>
        </BlurbackgroundContainer>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" duration={1} delay={100}>
        <FAQContainer>
          {/* FAQ section */}
          <FlexWrapper direction={"column"} margin={"30px auto"}>
            <Text2
              color={"white"}
              weight={900}
              margin={"30px auto"}
              fontFamily={"Inter"}
            >
              FAQ
            </Text2>
            <FlexWrapper wrap={"wrap"} gap={"30px"} justify={"space-between"}>
              <FAQPoints width={"45%"}>
                <Text4_5 color={"white"} margin={"0px 5px 0px 0px"}>
                  What's the cost of Escribelo?
                </Text4_5>
                <ExpandIcon src={DownArrow} />
              </FAQPoints>
              <FAQPoints width={"45%"}>
                <Text4_5 color={"white"} margin={"0px 5px 0px 0px"}>
                  What's the cost of Escribelo?
                </Text4_5>
                <ExpandIcon src={DownArrow} />
              </FAQPoints>
              <FAQPoints width={"45%"}>
                <Text4_5 color={"white"} margin={"0px 5px 0px 0px"}>
                  What examples I can use Escribelo for?
                </Text4_5>
                <ExpandIcon src={DownArrow} />
              </FAQPoints>
              <FAQPoints width={"45%"}>
                <Text4_5 color={"white"} margin={"0px 5px 0px 0px"}>
                  What examples I can use Escribelo for?
                </Text4_5>
                <ExpandIcon src={DownArrow} />
              </FAQPoints>
              <FAQPoints width={"45%"}>
                <Text4_5 color={"white"} margin={"0px 5px 0px 0px"}>
                  What's the cost of Escribelo?
                </Text4_5>
                <ExpandIcon src={DownArrow} />
              </FAQPoints>
              <FAQPoints width={"45%"}>
                <Text4_5 color={"white"} margin={"0px 5px 0px 0px"}>
                  What's the cost of Escribelo?
                </Text4_5>
                <ExpandIcon src={DownArrow} />
              </FAQPoints>
            </FlexWrapper>
          </FlexWrapper>

          {/* OUR Mission section */}
          <FlexWrapper direction={"column"} margin={"160px auto"}>
            <Text3 color={"white"} weight={900} fontFamily={"Inter"}>
              Read Over 100+ reviews that rated Escribelo <br /> 4.9/5 stars
            </Text3>
            <Text5 color={"white"} weight={700}>
              Our mission is to help people break through writer's block to
              finally <br /> get their content done! We can't wait to see what
              you create with <br /> your AI assistant
            </Text5>

            <FlexRowWrapper
              wrap={"wrap"}
              justify={"space-around"}
              margin={"30px auto"}
            >
              {Array.from(Array(8).keys()).map((item, index) => (
                <ShopifyImageWrapper key={index}>
                  <ShopifyImage src={ShopifyImageImage} />
                </ShopifyImageWrapper>
              ))}
            </FlexRowWrapper>
          </FlexWrapper>
        </FAQContainer>
        {/* Grid */}
      </ScrollAnimation>

      <BottomBgBackgroundConatiner>
        <ScrollAnimation animateIn="fadeIn" duration={1} delay={100}>
          {/* <BackgroundImageContainer> */}
            <Container>
              <CustomGrid />
            </Container>
            <TempeleteOne
              heading1={"Create Content Faster With Artificial"}
              heading2={" Intelligence"}
              description={
                "Stop spending so much time writing blog articles, social media posts, and sales emails... let Escribelo write for you."
              }
              ButtonTitle={"Get Started"}
            />
          {/* </BackgroundImageContainer> */}
        </ScrollAnimation>
      </BottomBgBackgroundConatiner>
    </>
  );
};

export default SectionThree;
